import { gql, TypedDocumentNode } from '@common/hooks';
import {
  MissionControlPaginatedStaffingRequestsQueryCgResponse,
  MissionControlPaginatedStaffingRequestsQueryVariables,
} from '@common/graphql';

export type MissionControlStaffingRequestType = NonNullable<
  MissionControlPaginatedStaffingRequestsQueryCgResponse['missionControlPaginatedStaffingRequests']['staffingRequests']
>[number];

export const MISSION_CONTROL_PAGINATED_STAFFING_REQUESTS_QUERY: TypedDocumentNode<
  MissionControlPaginatedStaffingRequestsQueryCgResponse,
  MissionControlPaginatedStaffingRequestsQueryVariables
> = gql`
  query MissionControlPaginatedStaffingRequests(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection!
    $orderField: MissionControlStaffingRequestOrderField!
    $filters: MissionControlStaffingRequestFilterInput
    $staffingRequestTypes: [StaffingRequestType!]
  ) {
    missionControlPaginatedStaffingRequests(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
      staffingRequestTypes: $staffingRequestTypes
    ) {
      totalCount
      staffingRequests {
        id
        code
        startDate
        secondsUntilStartDate
        timeUntilStartDateForUpcomingJobsType
        timeUntilStartDateForReviewsPendingType
        openStaffingRequestPositionsCount
        staffingRequestApplicationsCount
        offeredOffersStaffingRequestApplicationsCount
        inReviewStaffingRequestApplicationsCount
        submissionsPaused
        canUpdate {
          value
        }
        role {
          id
          abbreviation
        }
        organizationBusiness {
          id
          name
        }
        organizationUnit {
          id
          clinicalUnit {
            id
            displayName
          }
        }
        hiringLeader {
          id
          name
        }
      }
    }
  }
`;
